import React, { useState } from 'react'

export default function Button(props) {

  return (
    <>
        <button
            type={props?.type}
            disabled={props.isLoading}
            className={`${props?.className} ${props.isLoading === true ? "disable-btn" : ""}`}            
            {...props}
        >
            {
                props.isLoading === true ? "Please Wait..." : props.name
            }
        </button>
    </>
  )
}
